import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkUpdateFaqGroups } from "../api/bulkUpdateFaqGroups";
import { createFaqGroup } from "../api/createFaqGroup";
import {
  getFaqGroupsQueryData,
  invalidateFaqGroupsQuery,
} from "../queries/useFaqGroupsQuery";
import { FaqGroupDataToCreate } from "../types";

type Params = {
  data: FaqGroupDataToCreate;
};

export const useCreateFaqGroupMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ data }) => {
      const prevData = getFaqGroupsQueryData() || [];

      await Promise.all([
        createFaqGroup(data),
        bulkUpdateFaqGroups(
          prevData.map((page) => ({
            id: page.id,
            order: page.order + 1,
          })),
        ),
      ]);
    },
    onSuccess: () => {
      invalidateFaqGroupsQuery();
    },
    onError: (e) => {
      console.error("Error occurred when creating faq group", e);
    },
  });
};
